<template>
    <!-- Theme one -->
    <div v-if="themeStore.themeIndex == 1"
>
        <ChestUserDetails :data-set="dataSet" @onClickTab="onClickTab" @getNextPageMsgList="getNextPageMsgList" />
    </div>
    <div v-if="themeStore.themeIndex == 2">
        <ChestUserDetailsTwo :data-set="dataSet" @onClickTab="onClickTab" @getNextPageMsgList="getNextPageMsgList" />
    </div>
    <div v-if="themeStore.themeIndex == 3">
        <ChestUserDetailsThree :data-set="dataSet" @onClickTab="onClickTab" @getNextPageMsgList="getNextPageMsgList" />
    </div>

    <StatusPopup ref="statusRef" :is-show-success="isSuccess" :content="toastContent" />
    <LoadingScreen ref="loadingRef" />
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import StatusPopup from '@/components/common/statusPopup.vue';
import LoadingScreen from '@/components/common/loadingScreen.vue';
import { getPlayerClaimHistory } from '@/api/activity';
import ChestUserDetails from '@/themes/themeOne/activeChest/components/chestUserDetails.vue';
import ChestUserDetailsTwo from '@/themes/themeTwo/activeChest/components/chestUserDetails.vue';
import ChestUserDetailsThree from '@/themes/themeThree/activeChest/components/chestUserDetails.vue';
import { ChestUserData, PAGE_SIZE, PlayListItem } from '../supportScript';
import { useThemeStore } from '@/stores/theme';

const themeStore = useThemeStore()
const statusRef = ref()
const isSuccess = ref(false)
const toastContent = ref('')
const loadingRef = ref()

const activeTabStatus = ref<any>('')
const total = ref(0)
const pageSize = ref(PAGE_SIZE)
const pageNum = ref(1)
const playersList = ref<PlayListItem[]>([])


const dataSet = computed<ChestUserData>(() => ({
  playersList: playersList.value,
  total: total.value,
  pageSize: pageSize.value,
  pageNum: pageNum.value
}))

const onClickTab = (active: any) => {
    total.value = 0
    pageNum.value = 1
    playersList.value = []
    if (active.name == 0) {
        activeTabStatus.value = '' // all
        getHistory()
    } else if (active.name == 1) {
        activeTabStatus.value = 1 // active/completed
        getHistory()
    } else if (active.name == 2) {
        activeTabStatus.value = 2 // inactive/fail
        getHistory()
    } else if (active.name == 3) {
        activeTabStatus.value = 0 // pending
        getHistory()
    }

}
const getNextPageMsgList = () => {
    if (total.value > pageSize.value * pageNum.value) {
        pageNum.value = pageNum.value + 1
        getHistory()
    }
}
const showError = (message: string) => {
    toastContent.value = message;
    isSuccess.value = false;
    statusRef.value.open()
}

const getHistory = () => {
    loadingRef.value.open()
    let data = {
        status: activeTabStatus.value,
        pageNum: pageNum.value,
        pageSize: pageSize.value
    }
    getPlayerClaimHistory(data).then(res => {
        loadingRef.value.close()
        playersList.value = [...playersList.value, ...res.data?.records]
        total.value = res.data?.total || 0
    }).catch(err => {
        if (err.code != 401) {
            loadingRef.value.close();
            showError(err);
        }
    })
}
onMounted(() => {
    getHistory()
})
</script>
<style scoped>
.container {
    padding: 70px 0;

}

.container>>>.van-tabs__nav {
    background: transparent;
    padding: 0 15px;
}

.container>>>.van-tab {
    background: rgba(255, 255, 255, 0.04);
    color: rgba(255, 255, 255, 0.45);
    border-radius: 30px;
    font-size: 12px;
    margin: 5px;
    height: 35px;
    padding: 0 15px;
}

.container>>>.van-tab.van-tab--active {
    background-image: linear-gradient(180deg, #F8D8A7 0%, #F0A853 100%);
    color: #12151A;
    font-weight: 500;
}

.container>>>.van-tabs__line {
    background-color: transparent;
    height: 0px;
}

.content {
    color: #fff;
    padding: 15px;
}

.tabel_head {
    padding: 20px 10px;
    background: rgba(255, 255, 255, 0.25);
    box-shadow: inset 0px -1px 0px 0px rgba(255, 255, 255, 0.15);
    border-radius: 10px 10px 0 0;
    color: rgba(255, 255, 255, 0.85);
    font-weight: 700;
    font-size: 14px;
}

.tabel_alignment {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    text-align: center;
}

.tabel_row {
    color: rgba(255, 255, 255, 0.85);
    border-top: 1px solid rgba(255, 255, 255, 0.08);
    padding: 10px;
    font-size: 13px;
}

.tabel_row .van-col {
    padding: 10px 0;
    color: rgba(255, 255, 255, 0.65);
}

.table_container {
    margin-top: 5px;
}

.line {
    width: 1px;
    background: rgba(255, 255, 255, 0.15);
    height: 10px;
}

.no_more {
    color: #969799;
    display: flex;
    justify-content: center;
    padding: 10px;
    font-size: 14px;
}

.arrowDown {
    display: flex;
    justify-content: center;

}

.arrowDown img {
    width: 30px;
    transform: rotate(-90deg);
}
</style>